const Users = [
  {
    userId: "admin",
    pasd: "admin",
    name: "admin",
    basket: [2, 4, 6, 9, 19],
  },
  {
    userId: "suzy2",
    pasd: "222",
    name: "lee",
    basket: [1, 7, 9],
  },
  {
    userId: "suzy3",
    pasd: "333",
    name: "park",
    basket: [27, 20, 9],
  },
  {
    userId: "suzy4",
    pasd: "444",
    name: "yoon",
    basket: [11, 10, 9],
  },
  {
    userId: "suzy5",
    pasd: "555",
    name: "choi",
    basket: [3, 2, 1],
  },
];

export default Users;
